module.exports = __webpack_public_path__ + "static/media/nebulafix-2.0cd923ac.jpg";